import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { Paper } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';

import NewGroupModal from '../components/NewGroupModal';

import { MENU_WIDTH } from '../constants';
import { getGroups } from '../store/actions/admin';

const columns = [
  {
    id: 'name',
    label: 'Group Name',
    minWidth: 170,
    align: 'center',
  },
  {
    id: 'members',
    label: 'Members',
    minWidth: 170,
    format: (value) => {
      let retVal = '';
      if (value) {
        value.forEach((user, index) => {
          if (index > 0) retVal += ', ';
          retVal += `${user.first_name} ${user.last_name}`;
        });
      }
      return retVal;
    },
    align: 'center',
  },
  {
    id: 'patients',
    label: 'Patients',
    minWidth: 170,
    format: (value) => {
      let retVal = '';
      if (value) {
        value.forEach((patient, index) => {
          if (index > 0) retVal += ', ';
          retVal += `${patient.first_name} ${patient.last_name}`;
        });
      }
      return retVal;
    },
    align: 'center',
  },
];

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    paddingLeft: MENU_WIDTH,
    paddingTop: '6rem',
    height: '100%',
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: '2rem',
    marginTop: '2rem',
    justifyContent: 'flex-end',
    marginRight: '2rem',
  },
  paper: {
    margin: '2rem',
  },
  content: {
    flexGrow: 1,
    borderRadius: 4,
  },
  table: {
    width: '100%',
  },
  headerCell: {
    backgroundColor: '#526488',
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'white',
  },
  p: {
    margin: 0,
  },
  button: {
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
}));

const Groups = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const groupsList = useSelector((state) => state.admin.groupsList);
  const [isNewGroupModalOpen, setIsNewGroupModalOpen] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    dispatch(getGroups());
  }, []);

  const handleNavigation = (id) => {
    history.push(`./groups/${id}`);
  };

  return (
    <div className={classes.root}>
      <NewGroupModal open={isNewGroupModalOpen} setOpen={setIsNewGroupModalOpen} />
      <div className={classes.headerRow}>
        <Button className={classes.button} variant="contained" onClick={() => setIsNewGroupModalOpen(true)}>
          Add New Group
        </Button>
      </div>
      <Paper className={classes.paper}>
        <TableContainer className={classes.content}>
          <Table stickyHeader aria-label="sticky table" className={classes.table}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    className={classes.headerCell}
                    key={column.label}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {groupsList.map((row) => {
                return (
                  <TableRow className={classes.row} hover key={row.id} onClick={() => handleNavigation(row.id)}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align} className={classes.cell}>
                          {column.format ? column.format(value) : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default Groups;
